import { createNewModel } from "../actions/modelAction";
import { createNewCustomer, generateNewLicense } from "../actions/customerActions";
import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  customers: {
    marketsList: [],
    salesOfficeBasedMarketsList:[],
    expirationDatesList: [],
    statusList: [],
    customersList: [],
    companyTypeList: [],
    salesOfficeList: [],
    licenseByCustomerList: [],
    transactionByCustomerList: [],
    contactsByCustomerList: [],
    toolsList: [],
    transactionTypesList: [],
    discountsList: [],
    rolesList: [],
    userRegionList: [],
    userSalesOfficeList: [],
    isLoading: false,
    hasError: false,
  },
  createNewCustomer: {
    data: undefined,
    isLoading: false,
    hasError: false,
  },
  updateCustomer:{
    data: undefined,
    isLoading: false,
    hasError: false
  }, 
  deleteCustomer:{
    data:{},
    isLoading:false,
    hasError:false
  },
  generateNewLicense: {
    data: undefined,
    isLoading: false,
    hasError: false,
  },
  renewalLicense: {
    data: undefined,
    isLoading: false,
    hasError: false,
  },
  createNewLicense: {
    data: undefined,
    isLoading: false,
    hasError: false,
  },
  updateQuantity:{
    data: undefined,
    isLoading: false,
    hasError: false
  }, 
  createNewContact: {
    data: undefined,
    isLoading: false,
    hasError: false,
  },
  deleteCustomerContact:{
    data:undefined,
    isLoading:false,
    hasError:false
  },
  updateCustomerContact:{
    data:undefined,
    isLoading:false,
    hasError:false
  },
  marketsCheckbox:[],
  expirationDateCheckbox:[],
  statusCheckbox: [],
  renderCustomersListData:[]
};

export const customerReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GET_C_SALESOFFICE_MARKETS:
      return {
        ...newState,
        customers: { ...newState.customers, isLoading: true, hasError: false },
      };
    case actionTypes.GET_C_SALESOFFICE_MARKETS_SUCCESS:
      return {
        ...newState,
        customers: { ...newState.customers, salesOfficeBasedMarketsList: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_C_SALESOFFICE_MARKETS_FAILURE:
      return {
        ...newState,
        customers: { ...newState.customers, salesOfficeBasedMarketsList: action.payload, isLoading: false, hasError: true },
      };

      
      case actionTypes.GET_U_EXPIRATIONDATE:
        return {
          ...newState,
          customers: { ...newState.customers, isLoading: true, hasError: false },
        };
      case actionTypes.GET_U_EXPIRATIONDATE_SUCCESS:
        return {
          ...newState,
          customers: { ...newState.customers, expirationDatesList: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.GET_U_EXPIRATIONDATE_FAILURE:
        return {
          ...newState,
          customers: { ...newState.customers, expirationDatesList: action.payload, isLoading: false, hasError: true },
        };
        case actionTypes.GET_C_STATUS:
          return {
            ...newState,
            customers: { ...newState.customers, isLoading: true, hasError: false },
          };
        case actionTypes.GET_C_STATUS_SUCCESS:
          return {
            ...newState,
            customers: { ...newState.customers, statusList: action.payload, isLoading: false, hasError: false },
          };
        case actionTypes.GET_C_STATUS_FAILURE:
          return {
            ...newState,
            customers: { ...newState.customers, statusList: action.payload, isLoading: false, hasError: true },
          };

        case actionTypes.GET_C_CUSTOMERS:
          return {
            ...newState,
            customers: { ...newState.customers, isLoading: true, hasError: false },
          };
        case actionTypes.GET_C_CUSTOMERS_SUCCESS:
          return {
            ...newState,
            customers: { ...newState.customers, customersList: action.payload, isLoading: false, hasError: false },
          };
        case actionTypes.GET_C_CUSTOMERS_FAILURE:
          return {
            ...newState,
            customers: { ...newState.customers, customersList: action.payload, isLoading: false, hasError: true },
          };

          case actionTypes.GET_C_COMPANYTYPE:
          return {
            ...newState,
            customers: { ...newState.customers, isLoading: true, hasError: false },
          };
        case actionTypes.GET_C_COMPANYTYPE_SUCCESS:
          return {
            ...newState,
            customers: { ...newState.customers, companyTypeList: action.payload, isLoading: false, hasError: false },
          };
        case actionTypes.GET_C_COMPANYTYPE_FAILURE:
          return {
            ...newState,
            customers: { ...newState.customers, companyTypeList: action.payload, isLoading: false, hasError: true },
          };
          case actionTypes.CREATE_NEW_CUSTOMER_START:
            return{
              ...newState,
              createNewCustomer:{...newState.createNewCustomer,isLoading:true,hasError:false}
            }    
          case actionTypes.CREATE_NEW_CUSTOMER_SUCCESS:
            return{
              ...newState,
              createNewCustomer:{...newState.createNewCustomer,data:action.payload,isLoading:false,hasError:false}
            }  
          case actionTypes.CREATE_NEW_CUSTOMER_FAILURE:
            return{
              ...newState,
              createNewCustomer:{...newState.createNewCustomer,data:action.payload,isLoading:false,hasError:false}
            }
          case actionTypes.UPDATE_CUSTOMER_START:
            return{
              ...newState,
              updateCustomer:{...newState.updateCustomer,isLoading:true,hasError:false}
            }
          case actionTypes.UPDATE_CUSTOMER_SUCCESS:
            return{
              ...newState,
              updateCustomer:{...newState.updateCustomer,data:action.payload,isLoading:false,hasError:false}
            }      
          case actionTypes.UPDATE_CUSTOMER_FAILURE:
            return{
              ...newState,
              updateCustomer:{...newState.updateCustomer,data:action.payload,isLoading:false,hasError:true}
            } 

      case actionTypes.GET_C_LICENSE:
        return {
          ...newState,
          customers: { ...newState.customers, isLoading: true, hasError: false },
        };
      case actionTypes.GET_C_LICENSE_SUCCESS:
        return {
          ...newState,
          customers: { ...newState.customers, licenseByCustomerList: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.GET_C_LICENSE_FAILURE:
        return {
          ...newState,
          customers: { ...newState.customers, licenseByCustomerList: action.payload, isLoading: false, hasError: true },
        };
        case actionTypes.GET_CREATE_LICENSEKEY:
          return {
            ...newState,
            createNewLicense: { ...newState.createNewLicense, isLoading: true, hasError: false },
          };
        case actionTypes.GET_CREATE_LICENSEKEY_SUCCESS:
          return {
            ...newState,
            createNewLicense: { ...newState.createNewLicense, data: action.payload, isLoading: false, hasError: false },
          };
        case actionTypes.GET_CREATE_LICENSEKEY_FAILURE:
          return {
            ...newState,
            createNewLicense: { ...newState.createNewLicense, data: action.payload, isLoading: false, hasError: true },
          }; 
          
          case actionTypes.UPDATE_QUANTITY_START:
            return{
              ...newState,
              updateQuantity:{...newState.updateQuantity,isLoading:true,hasError:false}
            }
          case actionTypes.UPDATE_QUANTITY_SUCCESS:
            return{
              ...newState,
              updateQuantity:{...newState.updateQuantity,data:action.payload,isLoading:false,hasError:false}
            }      
          case actionTypes.UPDATE_QUANTITY_FAILURE:
            return{
              ...newState,
              updateQuantity:{...newState.updateQuantity,data:action.payload,isLoading:false,hasError:true}
            }

        case actionTypes.GET_C_TRANSACTION:
        return {
          ...newState,
          customers: { ...newState.customers, isLoading: true, hasError: false },
        };
      case actionTypes.GET_C_TRANSACTION_SUCCESS:
        return {
          ...newState,
          customers: { ...newState.customers, transactionByCustomerList: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.GET_C_TRANSACTION_FAILURE:
        return {
          ...newState,
          customers: { ...newState.customers, transactionByCustomerList: action.payload, isLoading: false, hasError: true },
        };

    case actionTypes.GET_U_SALESOFFICE:
      return {
        ...newState,
        users: { ...newState.users, isLoading: true, hasError: false },
      };
    case actionTypes.GET_U_SALESOFFICE_SUCCESS:
      return {
        ...newState,
        users: { ...newState.users, salesOfficeList: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_U_SALESOFFICE_FAILURE:
      return {
        ...newState,
        users: { ...newState.users, salesOfficeList: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.GET_U_ROLES:
      return {
        ...newState,
        users: { ...newState.users, isLoading: true, hasError: false },
      };
    case actionTypes.GET_U_ROLES_SUCCESS:
      return {
        ...newState,
        users: { ...newState.users, rolesList: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_U_ROLES_FAILURE:
      return {
        ...newState,
        users: { ...newState.users, rolesList: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.GET_USER_MAPPED_REGIONS:
      return {
        ...newState,
        users: { ...newState.users, isLoading: true, hasError: false },
      };
    case actionTypes.GET_USER_MAPPED_REGIONS_SUCCESS:
      return {
        ...newState,
        users: { ...newState.users, userRegionList: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_USER_MAPPED_REGIONS_FAILURE:
      return {
        ...newState,
        users: { ...newState.users, userRegionList: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.GET_USER_MAPPED_SALESOFFICE:
      return {
        ...newState,
        users: { ...newState.users, isLoading: true, hasError: false },
      };
    case actionTypes.GET_USER_MAPPED_SALESOFFICE_SUCCESS:
      return {
        ...newState,
        users: { ...newState.users, userSalesOfficeList: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_USER_MAPPED_SALESOFFICE_FAILURE:
      return {
        ...newState,
        users: { ...newState.users, userSalesOfficeList: action.payload, isLoading: false, hasError: true },
      };
    
    case actionTypes.CREATE_NEW_TOOL:
      return {
        ...newState,
        createNewUser: { ...newState.createNewUser, isLoading: true, hasError: false },
      };
    case actionTypes.CREATE_NEW_TOOL_SUCCESS:
      return {
        ...newState,
        createNewUser: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.CREATE_NEW_TOOL_FAILURE:
      return {
        ...newState,
        createNewUser: { data: action.payload, isLoading: false, hasError: true },
      };
    case actionTypes.REGION_SELECTION:
      return{
        ...newState,
        regionCheckbox: action.payload
      } 
      case actionTypes.MARKETS_SELECTION:
      return{
        ...newState,
        marketsCheckbox: action.payload
      } 
    case actionTypes.EXPIRATION_DATE_SELECTION:
      return{
        ...newState,
        expirationDateCheckbox: action.payload
      }   
    case actionTypes.STATUS_SELECTION:
      return{
        ...newState,
        statusCheckbox: action.payload
      }   
    case actionTypes.CUSTOMER_TABLE_DATA_CREATION:
      return{
        ...newState,
        renderCustomersListData:action.payload
      }
      case actionTypes.GET_TOOLS:
          return {
            ...newState,
            customers: { ...newState.customers, isLoading: true, hasError: false },
          };
        case actionTypes.GET_TOOLS_SUCCESS:
          return {
            ...newState,
            customers: { ...newState.customers, toolsList: action.payload, isLoading: false, hasError: false },
          };
        case actionTypes.GET_TOOLS_FAILURE:
          return {
            ...newState,
            customers: { ...newState.customers, toolsList: action.payload, isLoading: false, hasError: true },
          }; 
          case actionTypes.GET_TRANSACTION_TYPE:
          return {
            ...newState,
            customers: { ...newState.customers, isLoading: true, hasError: false },
          };
        case actionTypes.GET_TRANSACTION_TYPE_SUCCESS:
          return {
            ...newState,
            customers: { ...newState.customers, transactionTypesList: action.payload, isLoading: false, hasError: false },
          };
        case actionTypes.GET_TRANSACTION_TYPE_FAILURE:
          return {
            ...newState,
            customers: { ...newState.customers, transactionTypesList: action.payload, isLoading: false, hasError: true },
          }; 
          case actionTypes.GET_DISCOUNTS:
          return {
            ...newState,
            customers: { ...newState.customers, isLoading: true, hasError: false },
          };
        case actionTypes.GET_DISCOUNTS_SUCCESS:
          return {
            ...newState,
            customers: { ...newState.customers, discountsList: action.payload, isLoading: false, hasError: false },
          };
        case actionTypes.GET_DISCOUNTS_FAILURE:
          return {
            ...newState,
            customers: { ...newState.customers, discountsList: action.payload, isLoading: false, hasError: true },
          };
          case actionTypes.CREATE_NEW_GENERATELICENSE_START:
                return {
                  ...newState,
                  generateNewLicense: { ...newState.generateNewLicense, isLoading: true, hasError: false },
                };
              case actionTypes.CREATE_NEW_GENERATELICENSE_SUCCESS:
                return {
                  ...newState,
                  generateNewLicense: { ...newState.generateNewLicense, data: action.payload, isLoading: false, hasError: false },
                };
              case actionTypes.CREATE_NEW_GENERATELICENSE_FAILURE:
                return {
                  ...newState,
                  generateNewLicense: { ...newState.generateNewLicense, data: action.payload, isLoading: false, hasError: true },
                };


                case actionTypes.RENEWAL_LICENSE_START:
                return {
                  ...newState,
                  renewalLicense: { ...newState.renewalLicense, isLoading: true, hasError: false },
                };
              case actionTypes.RENEWAL_LICENSE_SUCCESS:
                return {
                  ...newState,
                  renewalLicense: { ...newState.renewalLicense, data: action.payload, isLoading: false, hasError: false },
                };
              case actionTypes.RENEWAL_LICENSE_FAILURE:
                return {
                  ...newState,
                  renewalLicense: { ...newState.renewalLicense, data: action.payload, isLoading: false, hasError: true },
                };
                case actionTypes.GET_CUSTOMER_CONTACTS:
                  return {
                    ...newState,
                    customers: { ...newState.customers, isLoading: true, hasError: false },
                  };
                case actionTypes.GET_CUSTOMER_CONTACTS_SUCCESS:
                  return {
                    ...newState,
                    customers: { ...newState.customers, contactsByCustomerList: action.payload, isLoading: false, hasError: false },
                  };
                case actionTypes.GET_CUSTOMER_CONTACTS_FAILURE:
                  return {
                    ...newState,
                    customers: { ...newState.customers, contactsByCustomerList: action.payload, isLoading: false, hasError: true },
                  }; 
          case actionTypes.CREATE_NEW_CONTACT:
            return{
              ...newState,
              createNewContact:{...newState.createNewContact,isLoading:true,hasError:false}
            }    
          case actionTypes.CREATE_NEW_CONTACT_SUCCESS:
            return{
              ...newState,
              createNewContact:{...newState.createNewContact,data:action.payload,isLoading:false,hasError:false}
            }  
          case actionTypes.CREATE_NEW_CONTACT_FAILURE:
            return{
              ...newState,
              createNewContact:{...newState.createNewContact,data:action.payload,isLoading:false,hasError:false}
            }        
            case actionTypes.DELETE_CUSTOMERCONTACT_START:
      return{
        ...newState,
        deleteCustomerContact:{...newState.deleteCustomerContact,isLoading:true,hasError:false}
      }  
    case actionTypes.DELETE_CUSTOMERCONTACT_SUCCESS:
      return{
        ...newState,
        deleteCustomerContact:{...newState.deleteCustomerContact,data:action.payload,isLoading:false,hasError:false}
      }  
    case actionTypes.DELETE_CUSTOMERCONTACT_FAILURE:
      return{
        ...newState,
        deleteCustomerContact:{...newState.deleteCustomerContact,data:action.payload,isLoading:false,hasError:true}
      }
      case actionTypes.UPDATE_CUSTOMER_CONTACT:
            return{
              ...newState,
              updateCustomerContact:{...newState.updateCustomerContact,isLoading:true,hasError:false}
            }
          case actionTypes.UPDATE_CUSTOMER_CONTACT_SUCCESS:
            return{
              ...newState,
              updateCustomerContact:{...newState.updateCustomerContact,data:action.payload,isLoading:false,hasError:false}
            }      
          case actionTypes.UPDATE_CUSTOMER_CONTACT_FAILURE:
            return{
              ...newState,
              updateCustomerContact:{...newState.updateCustomerContact,data:action.payload,isLoading:false,hasError:true}
            }   
          case actionTypes.DELETE_CUSTOMERS_START:
                  return {
                    ...newState,
                    deleteCustomer: { ...newState.deleteCustomer, isLoading: true, hasError: false },
                  };
                case actionTypes.DELETE_CUSTOMER_SUCCESS:
                  return {
                    ...newState,
                    deleteCustomer: { ...newState.deleteCustomer, data: action.payload, isLoading: false, hasError: false },
                  };
                case actionTypes.DELETE_CUSTOMER_FAILURE:
                  return {
                    ...newState,
                    deleteCustomer: { ...newState.deleteCustomer, data: action.payload, isLoading: false, hasError: true },
                  };       
    default:
      return { ...newState };
  }
};
